import { Observable } from 'rxjs';
import { ColorShadeValue } from '../../models/colorshade/colorshade-value';
import { ODataResponse } from '../../models/odata-response';

export abstract class IColorshadeService {
    public abstract getColorShadesByEanCode(eanCode: string): Observable<ODataResponse<ColorShadeValue[]>>;

}
